var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3089(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3089",
    "data-name": "Group 3089",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.654,
    height: 43,
    viewBox: "0 0 45.654 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_70131",
    "data-name": "Path 70131",
    d: "M177.237,24.941a.41.41,0,0,1-.169-.024L154.96,17.925a.564.564,0,0,1-.41-.53.572.572,0,0,1,.386-.555l22.109-8.149a.6.6,0,0,1,.41,0l22.109,8.149a.6.6,0,0,1,.386.555.565.565,0,0,1-.41.53L177.43,24.917A.6.6,0,0,1,177.237,24.941Zm-20.324-7.619,20.3,6.437,20.3-6.437-20.3-7.5Z",
    transform: "translate(-154.55 -8.655)",
    fill: "#cf2969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_70132",
    "data-name": "Path 70132",
    d: "M162.648,13.6a.6.6,0,0,1-.555-.386.58.58,0,0,1,.338-.747l8.414-3.11a.58.58,0,1,1,.41,1.085l-8.414,3.11A.745.745,0,0,1,162.648,13.6Z",
    transform: "translate(-143.963 -7.726)",
    fill: "#cf2969"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_70133",
    "data-name": "Path 70133",
    d: "M172.863,28.367a36.558,36.558,0,0,1-13.935-2.845,2.14,2.14,0,0,1-1.278-1.953V13.588a.549.549,0,0,1,.241-.458.587.587,0,0,1,.53-.1l14.466,4.581,14.466-4.581a.614.614,0,0,1,.53.1.621.621,0,0,1,.241.458V23.57a2.14,2.14,0,0,1-1.278,1.953A37.6,37.6,0,0,1,172.863,28.367ZM158.807,14.384V23.57a.916.916,0,0,0,.579.868,35.734,35.734,0,0,0,13.477,2.748,35.734,35.734,0,0,0,13.477-2.748.94.94,0,0,0,.579-.868V14.384l-13.887,4.388a.47.47,0,0,1-.362,0Z",
    transform: "translate(-150.176 -2.51)",
    fill: "#cf2969"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_70134",
    "data-name": "Path 70134",
    d: "M168.692,20.661a36.294,36.294,0,0,1-9.764-2.58,2.14,2.14,0,0,1-1.278-1.953.579.579,0,0,1,1.157,0,.916.916,0,0,0,.579.868,35.175,35.175,0,0,0,9.379,2.483.594.594,0,0,1-.072,1.181Z",
    transform: "translate(-150.176 1.074)",
    fill: "#cf2969"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_70135",
    "data-name": "Path 70135",
    d: "M171.979,28.147a.587.587,0,0,1-.579-.579V13.079a.579.579,0,0,1,1.157,0v14.49A.587.587,0,0,1,171.979,28.147Z",
    transform: "translate(-130.775 -3.23)",
    fill: "#cf2969"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_70136",
    "data-name": "Path 70136",
    d: "M173.982,26.5a4,4,0,1,1,4-4A4.008,4.008,0,0,1,173.982,26.5Zm0-6.823A2.821,2.821,0,1,0,176.8,22.5,2.824,2.824,0,0,0,173.982,19.681Z",
    transform: "translate(-132.779 5.236)",
    fill: "#cf2969"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_70137",
    "data-name": "Path 70137",
    d: "M173.982,26.5a4,4,0,1,1,4-4A4.008,4.008,0,0,1,173.982,26.5Zm0-6.823A2.821,2.821,0,1,0,176.8,22.5,2.824,2.824,0,0,0,173.982,19.681Z",
    transform: "translate(-132.779 5.236)",
    fill: "#cf2969"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_70138",
    "data-name": "Path 70138",
    d: "M176.56,34.434h-4.653a2.143,2.143,0,0,1-1.591-.723,2.1,2.1,0,0,1-.506-1.664l1.326-10.656a.623.623,0,0,1,.313-.458.583.583,0,0,1,.7.121,2.81,2.81,0,0,0,4.2,0,.6.6,0,0,1,.675-.145.654.654,0,0,1,.338.458l1.326,10.656a2.188,2.188,0,0,1-.506,1.664A2.1,2.1,0,0,1,176.56,34.434Zm-4.412-11.862-1.206,9.62a.942.942,0,0,0,.241.747.917.917,0,0,0,.723.313h4.653a1,1,0,0,0,.723-.313.97.97,0,0,0,.241-.747l-1.206-9.62A4.048,4.048,0,0,1,172.148,22.572Z",
    transform: "translate(-133.042 8.566)",
    fill: "#cf2969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3089);
export default __webpack_public_path__ + "static/media/Group 3089.d04ed2bcb42acda43c2c8554032a8cb1.svg";
export { ForwardRef as ReactComponent };